import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/centourio_logo.svg")